// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var MomentRe$ReactHooksTemplate = require("../../MomentRe.res.js");

function make(from, to_) {
  return {
          from: from,
          to_: to_
        };
}

function from(t) {
  return t.from;
}

function to_(t) {
  return t.to_;
}

function getMomentString(date) {
  if (date !== undefined) {
    return Caml_option.valFromOption(date).format("DD/MM/YYYY");
  } else {
    return "";
  }
}

function toString(t) {
  return "from: " + (getMomentString(t.from) + (" to: " + getMomentString(t.to_)));
}

function encode(t) {
  return Json_encode.object_(Belt_List.concat(Utils$ReactHooksTemplate.encodeOptionalMomentDateParamToList("start_date", t.from), Utils$ReactHooksTemplate.encodeOptionalMomentDateParamToList("end_date", t.to_)));
}

function convertDateToMoment(date) {
  if (date !== undefined) {
    return Caml_option.some(MomentRe$ReactHooksTemplate.moment(undefined, date));
  }
  
}

function decode(json) {
  return {
          from: convertDateToMoment(Json_decode.withDefault(undefined, (function (param) {
                      return Json_decode.field("start_date", (function (param) {
                                    return Json_decode.optional(Json_decode.string, param);
                                  }), param);
                    }), json)),
          to_: convertDateToMoment(Json_decode.withDefault(undefined, (function (param) {
                      return Json_decode.field("end_date", (function (param) {
                                    return Json_decode.optional(Json_decode.string, param);
                                  }), param);
                    }), json))
        };
}

exports.make = make;
exports.getMomentString = getMomentString;
exports.toString = toString;
exports.encode = encode;
exports.decode = decode;
exports.from = from;
exports.to_ = to_;
/* Utils-ReactHooksTemplate Not a pure module */
